import { CategoryCodes, isConsentGiven } from '@olxeu-eprivacy-storage/js';
import { getHydraConfig } from '@/config/hydra';
import { getNinjaConfig } from '@/config/ninja';
import { Tracker } from '@/generated/types.generated.ts';
import { getLogger } from '@/logger';

const logger = getLogger('consent');
const REQUIRED_CATEGORIES_FOR_3RD_PARTY = [CategoryCodes.C0002, CategoryCodes.C0003];
export const trackersWithoutConsent: Tracker[] = ['hydra', 'braze'];
/**
 * Checks for consent for specific tracker
 */
export function hasRequiredConsentFor(tracker: Tracker) {
  // when in native mode no tracking is allowed. The tracking is done by the native app
  if (getNinjaConfig().isNative) {
    return false;
  }
  // Hydra is always allowed
  if (!isEprivacyStorageRequired() || trackersWithoutConsent.includes(tracker)) {
    return true;
  }
  // 3rd party trackers need C0002 and C0003
  return REQUIRED_CATEGORIES_FOR_3RD_PARTY.every(isConsentGiven);
}

/**
 * Only some regions/countries are required to comply to GDPR.
 * When in native mode, ignore the consent - the native app will handle it
 */
export function isEprivacyStorageRequired() {
  if (getNinjaConfig().isNative) {
    return false;
  }

  return !!getHydraConfig().eprivacy_scope;
}

/**
 * Push required consent into the respective layer.
 * Does not try to redefine `window.gtag`
 * @param dataLayerName
 */
export function setDefaultGoogleConsents(dataLayerName: string = 'dataLayer') {
  const verb = 'granted';
  logger.debug(`Setting default Google consents to '${verb}' for "${dataLayerName}"`);

  (window as any)[dataLayerName] = (window as any)[dataLayerName] || [];

  const helperFn = function gtag() {
    // oxlint-disable-next-line
    (window as any)[dataLayerName].push(arguments);
  };

  // @ts-expect-error - the function uses arguments
  helperFn('consent', 'default', {
    ad_storage: verb,
    ad_user_data: verb,
    ad_personalization: verb,
    analytics_storage: verb,
  });
}
